import { useFiltersState } from "PFApp/components/filters_v2";
import { Button } from "PFComponents/button";
import { useTranslation } from "react-i18next";

type FiltersV2ResetAllButtonProps = {
  onReset: VoidFunction;
};
export const FiltersV2ResetAllButton = ({ onReset }: FiltersV2ResetAllButtonProps) => {
  const { t } = useTranslation("filters", { keyPrefix: "panel" });
  const { hasAnyFilterDefinedDefaultValue } = useFiltersState();

  return (
    <Button
      kind="text"
      onClick={onReset}
      icon={hasAnyFilterDefinedDefaultValue ? "history" : "filter-clean"}
      text={hasAnyFilterDefinedDefaultValue ? t("resetAll") : t("clearAll")}
    />
  );
};
